import { instance } from '../rdpInstance';

export const listProductTypes = (param) => instance.post('product_cluster/listproducttypes', param);
export const listProductCluster = (param) => instance.post('product_cluster/listproductcluster', param);
export const addProductCluster = (param) => instance.post('product_cluster/addproductcluster', param);
export const updateApiAddr = (param) => instance.post('product_cluster/updateapiaddr', param);
export const updateProductVersion = (param) => instance.post('product_cluster/updateproductversion', param);
export const deleteProductCluster = (param) => instance.post('product_cluster/deleteproductcluster', param);
